import { render } from "./forgotPassword.vue?vue&type=template&id=169691de"
import script from "./forgotPassword.vue?vue&type=script&lang=js"
export * from "./forgotPassword.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./forgotPassword.vue?vue&type=style&index=0&id=169691de&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/anita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__